/** @jsxRuntime classic /
/* @jsx jsx */
import { css, jsx, keyframes } from "@emotion/core";

import React from "react";
import { SCREENS } from "./utils";
import colors from "../../common/colors";
import styled from "@emotion/styled";

const moveLeft = css`
  left: 60px;
  top: 80px;
  fill: ${colors.white};
  transform: translate(0, 0) scale(0.7);
`;
const logoAnimation = {};
logoAnimation[SCREENS.GET_STARTED] = keyframes`
  30%, 60% {
    top: 15%;
    left: 50%;
    fill: ${colors.white};
    transform: translate(-50%, -50%) scale(1);
  }
  80%, 95% {
    top: 10%;
    left: 50%;
    fill: ${colors.white};
    transform: translate(-50%, -50%) scale(0.7);
  }
  100% {
    ${moveLeft}
  }
`;

const trans = {};
trans[SCREENS.SPLASH] = css`
  transform: translate(-50%, -50%) scale(1.5);
`;
trans[SCREENS.GET_STARTED] = trans[SCREENS.SPLASH];
trans[SCREENS.LANGUAGE_SELECTION] = css`
  ${moveLeft}
  top: -15%;
`;

const LogoHolder = styled.div`
  width: 100px;
  position: absolute;
  z-index: 2;
  top: 50%;
  left: 50%;
  ${p => trans[p.screen] || trans[SCREENS.SPLASH]}
  transform-origin: center;
  fill: ${colors.white};

  animation-name: ${p => logoAnimation[p.screen] || "none"};
  animation-duration: ${p => p.animationDuration || 0}ms;
  animation-delay: ${p => p.animationDelay || 0}ms;
  animation-timing-function: ease-in-out;
  animation-fill-mode: forwards;
`;

const Logo = props => {
  return (
    <LogoHolder data-testid="logo" {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 60 21.551"
      >
        <path
          d="M4321.633-629.01v4.574a.294.294 0 0 1-.086.207.29.29 0 0 1-.207.086h-2.572a.29.29 0 0 1-.208-.086.291.291 0 0 1-.087-.207v-4.577a1.762 1.762 0 0 0-.056-.44 1.687 1.687 0 0 0-.161-.4 1.75 1.75 0 0 0-.528-.58 1.708 1.708 0 0 0-.747-.286h-.056l-.074-.006h-.074a1.689 1.689 0 0 0-1.229.514 1.773 1.773 0 0 0-.511 1.242v4.538a.294.294 0 0 1-.086.207.294.294 0 0 1-.208.086h-2.572a.292.292 0 0 1-.208-.086.292.292 0 0 1-.086-.207v-4.581-.059-.059a4.841 4.841 0 0 1 1.073-2.925 4.9 4.9 0 0 1 2.58-1.672h.018a5.078 5.078 0 0 1 1.683-.121 4.858 4.858 0 0 1 1.529.407l.085.04.085.041.042.022.042.021.044.024.042.024a4.891 4.891 0 0 1 1.829 1.755 4.847 4.847 0 0 1 .704 2.504zm-22.347 4.846h-2.571a.292.292 0 0 1-.208-.086.292.292 0 0 1-.085-.207v-14.023a.292.292 0 0 1 .085-.208.293.293 0 0 1 .208-.086h2.571a.3.3 0 0 1 .208.086.293.293 0 0 1 .086.208v14.021a.293.293 0 0 1-.086.207.3.3 0 0 1-.208.087zm-4.135-6.961v.5a.292.292 0 0 1-.08.2.289.289 0 0 1-.194.086h-1.177a4.256 4.256 0 0 1 .409 1.242 4.158 4.158 0 0 1 .006 1.253 4.1 4.1 0 0 1-1.189 2.406 4.554 4.554 0 0 1-2.549 1.2 8.82 8.82 0 0 1-.993.083c-.332.011-.667.01-1 .009h-.727a.817.817 0 0 0-.529.2.66.66 0 0 0-.224.487.534.534 0 0 0 .169.423.77.77 0 0 0 .51.16h1.035c.628 0 1.405 0 2.1.006s1.3.026 1.577.062a3.393 3.393 0 0 1 1.949.89 2.941 2.941 0 0 1 .884 1.738 4.324 4.324 0 0 1-.338 1.82 7.488 7.488 0 0 1-.456.978.266.266 0 0 1-.1.114.308.308 0 0 1-.159.043h-3.063a.294.294 0 0 1-.209-.083.3.3 0 0 1-.085-.208v-.348-.411a.855.855 0 0 0-.2-.633.864.864 0 0 0-.637-.2c-.583 0-1.166.007-1.747.014s-1.167.013-1.75.013c-.128 0-.255 0-.383-.015a3.267 3.267 0 0 1-.379-.053 3.25 3.25 0 0 1-1.559-.729 2.8 2.8 0 0 1-.845-1.5 3.244 3.244 0 0 1 .12-1.877 3.165 3.165 0 0 1 1.129-1.472c.083-.06.169-.117.254-.174l.255-.169a.062.062 0 0 0 0-.072.163.163 0 0 0-.034-.04 3.961 3.961 0 0 1-1.719-1.947 5.158 5.158 0 0 1-.248-2.566 4.319 4.319 0 0 1 .965-2.282 5.277 5.277 0 0 1 2.04-1.436 5.891 5.891 0 0 1 1.014-.323 6.336 6.336 0 0 1 1.03-.139H4294.858a.3.3 0 0 1 .205.083.3.3 0 0 1 .082.2V-631.12zm-4.143 2.11a2.233 2.233 0 0 0-.657-1.584 2.231 2.231 0 0 0-1.583-.656 2.229 2.229 0 0 0-1.584.656 2.233 2.233 0 0 0-.657 1.584 2.235 2.235 0 0 0 .657 1.584 2.23 2.23 0 0 0 1.584.656 2.232 2.232 0 0 0 1.583-.656 2.235 2.235 0 0 0 .658-1.586zm38.032 1.037h2.878a.29.29 0 0 1 .23.112.289.289 0 0 1 .055.25 4.874 4.874 0 0 1-1.7 2.664 4.848 4.848 0 0 1-3.035 1.061 4.853 4.853 0 0 1-3.481-1.465 4.849 4.849 0 0 1-1.387-3.523 4.85 4.85 0 0 1 1.412-3.3 4.851 4.851 0 0 1 3.29-1.445 4.85 4.85 0 0 1 3.124 1 4.875 4.875 0 0 1 1.765 2.683.288.288 0 0 1-.054.251.292.292 0 0 1-.231.113h-2.893a.06.06 0 0 1-.032-.009.065.065 0 0 1-.024-.024 1.722 1.722 0 0 0-.617-.623 1.706 1.706 0 0 0-.871-.237 1.718 1.718 0 0 0-1.278.568 1.718 1.718 0 0 0-.431 1.346 1.71 1.71 0 0 0 .5 1.03 1.709 1.709 0 0 0 1.039.485 1.718 1.718 0 0 0 .994-.205 1.731 1.731 0 0 0 .685-.693.072.072 0 0 1 .023-.025.068.068 0 0 1 .04-.015zm13.878-.858c0 .145 0 .288-.009.43s-.025.282-.047.42a.287.287 0 0 1-.1.176.3.3 0 0 1-.191.07h-6.535a2.244 2.244 0 0 0 .491.654 2.25 2.25 0 0 0 .695.436c.051.02.1.038.155.055s.108.031.162.043l.026.006.028.005.027.005h.03l.062.01.063.008H4338.386a2.21 2.21 0 0 0 .608-.185 2.245 2.245 0 0 0 .521-.34.079.079 0 0 1 .019-.012.069.069 0 0 1 .023 0h2.626a.29.29 0 0 1 .249.138.292.292 0 0 1 .015.285 4.9 4.9 0 0 1-1.784 2.017 4.851 4.851 0 0 1-2.664.761 4.862 4.862 0 0 1-3.375-1.412 4.862 4.862 0 0 1-1.452-3.359 4.856 4.856 0 0 1 1.41-3.533 4.861 4.861 0 0 1 3.516-1.445 4.86 4.86 0 0 1 3.373 1.415 4.856 4.856 0 0 1 1.448 3.35zm-2.865-1.15a2.249 2.249 0 0 0-.677-.808 2.228 2.228 0 0 0-.989-.411H4337.775l-.063.009-.062.01h-.03l-.027.006-.028.006-.026.006-.057.014-.055.015c-.044.012-.087.026-.129.041l-.126.048a2.232 2.232 0 0 0-.663.434 2.238 2.238 0 0 0-.472.636h4.016zm-29.464.97v4.577a.293.293 0 0 1-.085.206.3.3 0 0 1-.208.086h-2.043a.292.292 0 0 1-.207-.086.293.293 0 0 1-.087-.207v-.252a4.821 4.821 0 0 1-1.067.4 4.878 4.878 0 0 1-1.172.142 4.853 4.853 0 0 1-3.482-1.466 4.849 4.849 0 0 1-1.386-3.525 4.863 4.863 0 0 1 1.417-3.306 4.852 4.852 0 0 1 3.3-1.439 4.885 4.885 0 0 1 1.3.132 4.85 4.85 0 0 1 1.173.45 4.893 4.893 0 0 1 1.784 1.658 4.843 4.843 0 0 1 .763 2.377v.186l.001.065zm-2.63 0a2.231 2.231 0 0 0-.656-1.584 2.232 2.232 0 0 0-1.583-.656 2.233 2.233 0 0 0-1.584.656 2.235 2.235 0 0 0-.656 1.584 2.236 2.236 0 0 0 .656 1.584 2.234 2.234 0 0 0 1.584.656 2.233 2.233 0 0 0 1.583-.656 2.231 2.231 0 0 0 .657-1.586z"
          transform="translate(-4282.92 638.773)"
        />
      </svg>
    </LogoHolder>
  );
};

export default React.memo(Logo);
